import { Button } from '@fluentui/react-components';
import { ArrowDownloadRegular } from '@fluentui/react-icons';
import { type DataTableExport, useExport } from './hooks.js';
import { useStyles } from './styles.js';

type DataTableToolbarExportProps = {
    dataExportFunc: () => DataTableExport | null;
};

export function DataTableToolbarExport({ dataExportFunc }: DataTableToolbarExportProps) {
    const styles = useStyles();

    const { onExport } = useExport(dataExportFunc);

    return (
        <Button className={styles.button} onClick={onExport} icon={<ArrowDownloadRegular />} size="small">
            Export
        </Button>
    );
}
